import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { ChildrenPropType } from '../../services/proptypes';
import PostSubmissionMessage from '../PostSubmissionMessage';
import RecaptchaForm from '../RecaptchaForm';
var defaultProps = {
  success: false,
  error: false,
  loading: false,
  className: '',
  title: '',
  postSubmissionButtonMessage: undefined,
  onPostSubmissionClick: function onPostSubmissionClick() {},
  action: undefined,
  hideRecaptchaNotice: false
};
export default function ReSubmitRecaptchaForm(_ref) {
  var postSubmissionMessage = _ref.postSubmissionMessage,
    postSubmissionButtonMessage = _ref.postSubmissionButtonMessage,
    onPostSubmissionClick = _ref.onPostSubmissionClick,
    onSubmit = _ref.onSubmit,
    children = _ref.children,
    success = _ref.success,
    error = _ref.error,
    loading = _ref.loading,
    className = _ref.className,
    title = _ref.title,
    action = _ref.action,
    hideRecaptchaNotice = _ref.hideRecaptchaNotice;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPostSubmission = _useState2[0],
    setShowPostSubmission = _useState2[1];
  function handlePostSubmissionClick() {
    if (onPostSubmissionClick) {
      onPostSubmissionClick();
    }
    setShowPostSubmission(false);
  }
  function handleSubmit(_x, _x2) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, recaptchaToken) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onSubmit(event, recaptchaToken);
          case 2:
            if (postSubmissionMessage) {
              setShowPostSubmission(true);
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  if (showPostSubmission) {
    return /*#__PURE__*/React.createElement(PostSubmissionMessage, {
      message: postSubmissionMessage,
      buttonText: postSubmissionButtonMessage,
      onClick: handlePostSubmissionClick
    });
  }
  return /*#__PURE__*/React.createElement(RecaptchaForm, {
    className: className,
    onSubmit: handleSubmit,
    loading: loading,
    success: success,
    error: error,
    title: title,
    action: action,
    hideRecaptchaNotice: hideRecaptchaNotice
  }, function (_ref2) {
    var submitting = _ref2.submitting;
    return /*#__PURE__*/React.createElement(React.Fragment, null, typeof children === 'function' ? children({
      submitting: submitting
    }) : children);
  });
}
ReSubmitRecaptchaForm.defaultProps = defaultProps;